(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jalg-delivery-map"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jalg-delivery')) {
  customElements.define('jalg-delivery', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.init(this.events.signal);
    }

    disconnectedCallback() {
      this.events?.abort();
    }

    async init(signal) {
      const map = this.querySelector('.jd-map');
      const view = this.querySelector('.jd-view');
      const tip = this.querySelector('.jd-tip');
      const on = (el, type, fn) => el.addEventListener(type, fn, { signal });

      if (!map.firstElementChild) {
        try {
          const response = await fetch(this.dataset.src, { signal });
          if (!response.ok) throw new Error(response.status);
          map.innerHTML = await response.text();
        } catch (error) {
          if (!signal.aborted) this.classList.add('is-failed');
          return;
        }
      }
      if (signal.aborted) return;

      // Country names and currencies as the store shows them, keyed by ISO code.
      let data = {};
      try { data = JSON.parse(this.querySelector('.jd-data').textContent); } catch (error) {}
      const name = code => data[code]?.name || code;
      const active = new Set(this.dataset.codes.split(' ').filter(Boolean));
      const shapes = code => this.querySelectorAll(`[data-c="${code}"]`);

      map.querySelectorAll('[data-c]').forEach(shape => {
        shape.classList.toggle('is-on', active.has(shape.dataset.c));
        shape.classList.toggle('is-current', shape.dataset.c === this.dataset.current);
      });

      let lit = null;
      const highlight = code => {
        if (code === lit) return;
        if (lit) shapes(lit).forEach(el => el.classList.remove('is-hl'));
        lit = code;
        if (code) shapes(code).forEach(el => el.classList.add('is-hl'));
      };

      // Hover label (mouse only)
      const showTip = (code, x, y) => {
        highlight(code);
        tip.textContent = name(code);
        tip.style.left = x + 'px';
        tip.style.top = y + 'px';
        tip.hidden = false;
      };
      const hideTip = () => {
        if (pop.hidden) highlight(null);
        tip.hidden = true;
      };

      // Switching country uses the store's own localization form.
      const form = this.querySelector('.jd-form');
      // returnTo: page to land on afterwards. Without it, Shopify returns to
      // this page. Either way Shopify adds the new market's URL prefix.
      const switchTo = (code, returnTo) => {
        if (!form || code === this.dataset.current) return;
        form.elements.country_code.value = code;
        if (returnTo) {
          let input = form.elements.return_to;
          if (!input) {
            input = Object.assign(document.createElement('input'), { type:'hidden', name:'return_to' });
            form.append(input);
          }
          input.value = returnTo;
        }
        this.classList.add('is-switching');
        form.submit();
      };

      // Country card: opens from the map or from the list.
      const pop = this.querySelector('.jd-pop');
      const switchButton = pop.querySelector('.jd-switch');
      const here = pop.querySelector('.jd-here');
      let popCode = null, opener = null;

      const closePop = (restore = false) => {
        if (pop.hidden) return;
        pop.hidden = true;
        popCode = null;
        highlight(null);
        opener?.setAttribute('aria-expanded', 'false');
        if (restore) (opener || view).focus();
        opener = null;
      };
      // x: centre of the card. top/bottom: the point or element it opens from.
      const openPop = (code, x, top, bottom = top, from = null) => {
        closePop();
        hideTip();
        popCode = code;
        opener = from;
        opener?.setAttribute('aria-expanded', 'true');
        highlight(code);
        const isCurrent = code === this.dataset.current;
        pop.querySelector('strong').textContent = name(code);
        pop.querySelector('.jd-currency').textContent = data[code]
          ? (this.dataset.prices || 'Prices in [currency]').replace('[currency]', data[code].currency) : '';
        switchButton.textContent = (this.dataset.switch || 'Shop in [country]').replace('[country]', name(code)) + ' →';
        switchButton.hidden = isCurrent;
        here.hidden = !isCurrent;
        pop.hidden = false;

        const w = pop.offsetWidth, h = pop.offsetHeight;
        const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
        const gap = from ? 8 : 16;
        const y = bottom + gap + h <= innerHeight - 12 ? bottom + gap : top - h - gap;
        pop.style.left = clamp(x - w / 2, 12, innerWidth - w - 12) + 'px';
        pop.style.top = clamp(y, 12, innerHeight - h - 12) + 'px';
        (isCurrent ? pop.querySelector('.jd-close') : switchButton).focus({ preventScroll: true });
      };

      const codeAt = target => target.closest?.('.jd-map .is-on')?.dataset.c;

      on(map, 'pointermove', e => {
        if (e.pointerType !== 'mouse' || !pop.hidden) return;
        const code = codeAt(e.target);
        code ? showTip(code, e.clientX, e.clientY) : hideTip();
      });
      on(map, 'pointerleave', e => e.pointerType === 'mouse' && hideTip());
      on(map, 'click', e => {
        const code = codeAt(e.target);
        code ? openPop(code, e.clientX, e.clientY) : closePop();
      });
      on(switchButton, 'click', () => popCode && switchTo(popCode, this.dataset.shopUrl));
      on(pop.querySelector('.jd-close'), 'click', () => closePop(true));
      on(document, 'pointerdown', e => {
        if (!map.contains(e.target) && !pop.contains(e.target) &&
            !(opener && opener.contains(e.target))) { hideTip(); closePop(); }
      });
      on(document, 'keydown', e => e.key === 'Escape' && closePop(true));
      on(view, 'scroll', () => { hideTip(); closePop(); });
      on(window, 'scroll', () => { hideTip(); closePop(); });

      // List: clicking a country switches to it (and returns to this page).
      this.querySelectorAll('.jd-region li').forEach(li =>
        on(li.querySelector('.jd-country'), 'click', () => switchTo(li.dataset.c)));

      const pan = (x, y) => {
        view.scrollLeft = map.clientWidth * x - view.clientWidth / 2;
        view.scrollTop = map.clientHeight * y - view.clientHeight / 2;
      };
      on(this, 'click', e => {
        const region = e.target.closest('[data-region]');
        if (region) { hideTip(); closePop(); pan(...region.dataset.region.split(',').map(Number)); }
      });

      const mobile = matchMedia('(max-width:799px)');
      on(mobile, 'change', () => mobile.matches ? pan(.533, .21) : pan(0, 0));
      this.classList.add('is-ready');
      if (mobile.matches) requestAnimationFrame(() => pan(.533, .21));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jalg-retailers-map"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jalg-retailers')) {
  customElements.define('jalg-retailers', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.events?.abort();
    }
    init() {
      this.events?.abort();
      this.events = new AbortController();
      const on = (el, type, fn, capture = false) => el.addEventListener(type, fn, { signal:this.events.signal, capture });
      const find = selector => this.querySelector(selector);
      const map = find('.jr-map'), view = find('.jr-view'), pop = find('.jr-pop');
      if (!map) return;
      map.querySelectorAll('.jr-pin').forEach(pin => pin.remove());
      const svg = find('.jr-lines');
      svg.replaceChildren();
      const title = pop.querySelector('strong');
      const location = pop.querySelector('p');
      const website = pop.querySelector('a');
      const mobile = matchMedia('(max-width:799px)');
      const viewport = window.visualViewport;
      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
      let active, locked = false;
      const coefficients = [
        [12.22222246,4.2710710326e-16,-0.00087451832549,3.801477834e-05,2.2414338494e-14,13.836089418,3.3438252554e-14,-9.4317942925e-08],
        [12.205111423,-0.0058940811155,-0.0003042966615,-1.6266555589e-05,69.180443974,13.836089418,-1.4147735516e-06,4.7158970893e-07],
        [12.166000377,-0.010157033753,-0.00054829499534,-1.2059679427e-05,138.36088795,13.836089418,5.6590833629e-06,-1.7920412901e-06],
        [12.100000352,-0.016544489123,-0.00072919002279,4.4949668502e-05,207.54134024,13.835977187,-2.1221548079e-05,6.6965780056e-06],
        [12.004667224,-0.020465133333,-5.4944633986e-05,-6.9961345763e-05,276.7217759,13.836311803,7.9227123038e-05,-2.4994225416e-05],
        [11.892222331,-0.026261644017,-0.0011043645537,2.289955528e-07,345.90222818,13.835196761,-0.00029568726316,9.3280457445e-05],
        [11.733333299,-0.037288167463,-0.0011009301399,2.015652299e-05,415.08268047,13.839324393,0.001103520653,-0.00034812715838],
        [11.52188946,-0.046785689196,-0.00079858292172,-3.1966001051e-05,484.26309951,13.824150252,-0.0041183900524,-0.00048607183841],
        [11.264000025,-0.05716895744,-0.0012780777702,5.8818587333e-05,553.22038529,13.746601263,-0.011409417236,-0.00038553927957],
        [10.953555784,-0.065538366564,-0.00039579346333,-6.6419467634e-05,621.61977144,13.603553646,-0.017192568905,-0.00064972489835],
        [10.607667043,-0.074477702688,-0.0013920867007,4.0636934229e-05,689.12652483,13.382845848,-0.026938419483,-0.00058616700702],
        [10.205555492,-0.08535083394,-0.0007825314394,1.1427277117e-05,755.2942792,13.069525073,-0.035730919641,-0.00057621174835],
        [9.7606670767,-0.092319090472,-0.00061112213467,1.1431738126e-05,819.67670154,12.669059499,-0.044374124601,-0.00067958851739],
        [9.2852224062,-0.097572938883,-0.00043964555563,-2.7820955119e-05,881.82752534,12.174307865,-0.054567972404,-0.0011686920552],
        [8.7828887554,-0.10405597376,-0.00085695986296,-0.00010548144426,941.18881773,11.540971902,-0.072098297923,-1.5663122129e-06],
        [8.2280002975,-0.12053666353,-0.0024391766691,0.00023463488764,997.09104594,10.819888414,-0.072121728239,-0.0095368592209],
        [7.5936665951,-0.12733110992,0.0010803503359,7.6272903614e-05,1048.195344,9.3834016099,-0.21517462264,-0.0046982447112],
        [6.993555695,-0.11080678975,0.0022244445293,7.6272903614e-05,1089.1457157,6.8792925574,-0.28564828874,-0.0046982447112]
      ];
      const project = (lat, lon) => {
        const i = Math.min(17, Math.floor(Math.abs(lat) / 5));
        const t = Math.abs(lat) - i * 5;
        const c = coefficients[i];
        const polynomial = n => c[n] + t * (c[n+1] + t * (c[n+2] + t * c[n+3]));
        return [2327.5 + lon * polynomial(0), 1187 - Math.sign(lat) * polynomial(4)];
      };
      const entries = [...this.querySelectorAll('.jr-list li')].map((row, i) => {
        const parts = row.dataset.coordinates.split(',').map(value => value.trim());
        const [lat, lon] = parts.map(Number);
        const valid = parts.length === 2 && parts.every(Boolean) && Number.isFinite(lat) && Number.isFinite(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180;
        const error = row.querySelector('.jr-error');
        if (error) error.hidden = valid || !row.dataset.coordinates.trim();
        if (!valid) return null;
        const [x, y] = project(lat, lon);
        const [dx, dy] = row.dataset.offset.split(',').map(Number);
        const bx = clamp(x + dx, 45, 4710);
        const by = clamp(y + dy, 45, 2335);
        const pin = document.createElement('button');
        pin.type = 'button';
        pin.className = 'jr-pin';
        pin.textContent = i + 1;
        pin.style.left = bx / 4755 * 100 + '%';
        pin.style.top = by / 2380 * 100 + '%';
        pin.setAttribute('aria-label', `${i+1}: ${row.querySelector('.jr-name').textContent} — ${row.querySelector('.jr-location').textContent}`);
        pin.setAttribute('aria-haspopup', 'dialog');
        pin.setAttribute('aria-controls', pop.id);
        pin.setAttribute('aria-expanded', 'false');
        map.append(pin);
        return { row, pin, x, y, bx, by };
      }).filter(Boolean);
      const draw = (tag, attributes) => {
        const node = document.createElementNS('http://www.w3.org/2000/svg', tag);
        Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
        svg.append(node);
      };
      const dotRadius = 12;
      const dots = new Map();
      entries.forEach(({ x, y, bx, by }) => {
        const key = `${x.toFixed(3)},${y.toFixed(3)}`;
        dots.set(key, { cx:x, cy:y, r:dotRadius });
        const distance = Math.hypot(bx-x, by-y);
        if (distance > 65) {
          const ux = (bx-x)/distance, uy = (by-y)/distance;
          draw('path', { d:`M${x+ux*(dotRadius+1)},${y+uy*(dotRadius+1)} L${bx-ux*60},${by-uy*60}` });
        }
      });
      dots.forEach(dot => draw('circle', dot));
      const byPin = new Map(entries.map(entry => [entry.pin, entry]));
      const close = (restore = false) => {
        clearTimeout(this.timer);
        const previous = active;
        active?.setAttribute('aria-expanded', 'false');
        active = null;
        locked = false;
        pop.hidden = true;
        if (restore) previous?.focus();
      };
      const position = () => {
        if (!active) return;
        const x = viewport?.offsetLeft || 0;
        const y = viewport?.offsetTop || 0;
        const width = viewport?.width || innerWidth;
        const height = viewport?.height || innerHeight;
        pop.style.maxWidth = Math.max(0, width - 24) + 'px';
        pop.style.maxHeight = Math.max(0, height - 24) + 'px';
        const r = active.getBoundingClientRect();
        const w = pop.offsetWidth, h = pop.offsetHeight;
        const top = r.bottom + h + 24 <= y + height ? r.bottom + 12 : r.top - h - 12;
        pop.style.left = clamp(r.left + (r.width-w)/2, x+12, x+width-w-12) + 'px';
        pop.style.top = clamp(top, y+12, y+height-h-12) + 'px';
      };
      const show = (pin, lock = false) => {
        clearTimeout(this.timer);
        active?.setAttribute('aria-expanded', 'false');
        active = pin;
        locked = lock;
        const { row } = byPin.get(pin);
        const link = row.querySelector('a.jr-link');
        title.textContent = row.querySelector('.jr-name').textContent;
        location.textContent = row.querySelector('.jr-location').textContent;
        website.hidden = !link;
        if (link) website.href = link.href;
        else website.removeAttribute('href');
        pin.setAttribute('aria-expanded', 'true');
        pop.hidden = false;
        position();
      };
      const pan = (x, y) => {
        view.scrollLeft = map.clientWidth*x - view.clientWidth/2;
        view.scrollTop = map.clientHeight*y - view.clientHeight/2;
      };
      on(this, 'click', e => {
        const pin = e.target.closest('.jr-pin');
        const region = e.target.closest('[data-region]');
        if (pin) active === pin && locked ? close() : show(pin, true);
        else if (region) {
          close();
          pan(...region.dataset.region.split(',').map(Number));
        } else if (e.target.closest('.jr-close')) close(true);
      });
      on(this, 'pointerover', e => {
        if (e.pointerType !== 'mouse') return;
        const pin = e.target.closest('.jr-pin');
        if (pin || pop.contains(e.target)) clearTimeout(this.timer);
        if (pin && !locked && pin !== active) show(pin);
      });
      on(this, 'pointerout', e => {
        if (e.pointerType !== 'mouse' || locked || pop.contains(document.activeElement) || !e.target.closest('.jr-pin,.jr-pop')) return;
        const next = e.relatedTarget;
        if (next instanceof Element && this.contains(next) && next.closest('.jr-pin,.jr-pop')) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(close, 220);
      });
      on(document, 'pointerdown', e => {
        if (!pop.contains(e.target) && e.target !== active) close();
      });
      on(document, 'focusin', e => {
        if (active && e.target !== active && !pop.contains(e.target)) close();
      });
      on(document, 'keydown', e => {
        if (!active) return;
        if (e.key === 'Escape') close(true);
        else if (e.key === 'Tab' && !e.shiftKey && e.target === active) {
          e.preventDefault();
          pop.querySelector('.jr-close').focus();
        } else if (e.key === 'Tab' && e.shiftKey && e.target === pop.querySelector('.jr-close')) {
          e.preventDefault();
          active.focus();
        }
      });
      on(window, 'scroll', position, true);
      on(window, 'resize', position);
      if (viewport) ['scroll', 'resize'].forEach(type => on(viewport, type, position));
      on(mobile, 'change', () => {
        close();
        pan(mobile.matches ? .51 : 0, mobile.matches ? .20 : 0);
      });
      if (this.dataset.editor === 'true') {
        on(this, 'shopify:block:select', e => {
          const entry = entries.find(item => item.row.dataset.block === e.detail.blockId);
          if (entry) {
            if (mobile.matches) pan(entry.bx/4755, entry.by/2380);
            show(entry.pin, true);
          }
        });
        on(this, 'shopify:block:deselect', () => close());
      }
      this.classList.add('is-ready');
      if (mobile.matches) pan(.51, .20);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
